/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { createContext, useContext, useState } from "react";
import { TOKEN_ASYNC_STORAGE, USER_INFO_ASYNC_STORAGE, ePageLink } from "../common/constants";
import { useNavigate } from "react-router-dom";
import { TUser, TUserLogin } from "../graphql/schema";

export interface LoginUserInputs {
  username: string;
  password: string;
}
export interface AuthPayload {
  error?: any;
  access_token: string;
  userId: string;
  isFirstLogin: boolean;
  require2FA: boolean;
  message: string;
  phoneNumber?: string;
}

export interface SetPhonePayload {
  addPhoneNumber: boolean;
}

export interface OTPPayload {
  updatePhoneNumber: boolean;
}

export interface ChangePasswordPayload {
  changePassword: boolean;
}

interface IAuthContextState {
  accessToken?: string | null;
  refreshToken?: string;
  userName?: string;
  userId?: string | null;
  isFirstLogin?: boolean;
  phoneNumber?: string;
  require2FA?: boolean;
  isChangedPassword?: boolean;
}

export type TUserLoginContext = {
  accountLogin: TUserLogin;
  user: TUser;
  accessToken: string;
};

export interface IAuthContext {
  authState: IAuthContextState;
  setAuthState: (state: IAuthContextState) => void;
  userInfo: TUserLoginContext | null;
  setUserInfo: React.Dispatch<React.SetStateAction<TUserLoginContext | null>>;
  token: string;
}
export const AuthContext = createContext<IAuthContext | null>(null);

const AuthProvider: React.FC = ({ children }) => {
  const access_token = localStorage.getItem("NISSE_ACCESS_TOKEN");
  const user_id = localStorage.getItem("NISSE_UID");

  const [authState, setAuthState] = useState<IAuthContextState>({
    userId: user_id,
    accessToken: access_token,
    isFirstLogin: false,
  });
  const [userInfo, setUserInfo] = React.useState<TUserLoginContext | null>(null);
  const [token, setToken] = React.useState<string>('');
  const navigate = useNavigate();
  React.useEffect(() => {
    const localToken = localStorage.getItem(TOKEN_ASYNC_STORAGE)
    const userInfoLocal = localStorage.getItem(USER_INFO_ASYNC_STORAGE)
    if (!userInfo && !localToken) {
      navigate(ePageLink.LOGIN)
    } else {
      if (userInfo) {
        setToken(userInfo.accessToken)
        localStorage.setItem(TOKEN_ASYNC_STORAGE, userInfo.accessToken)
        localStorage.setItem(USER_INFO_ASYNC_STORAGE, JSON.stringify(userInfo))
      } else if (userInfoLocal) {
        setUserInfo(JSON.parse(userInfoLocal))
      }
      navigate("/tracking")
    }
  }, [userInfo, localStorage]);
  return (
    <AuthContext.Provider
      value={{
        authState,
        setAuthState,
        userInfo,
        setUserInfo,
        token,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export function useAuth(): IAuthContext | null {
  const authContext = useContext(AuthContext)!;
  return authContext;
}
